import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Paper,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SubjectIcon from "@mui/icons-material/Subject";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UpdateLession = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const [subjectName, setSubjectName] = useState([]);
  const [className, setClassName] = useState([]);
  const [topicName, setTopicName] = useState([]);
  const [formData, setFormData] = useState({
    class: '',
    subject: '',
    lession: '',
    Content: '',
    pdfFile: null,
  });

  const { LessionId } = useParams();

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    if (field === 'class') {
      fetchSubjectddl(value);
    } else if (field === 'subject') {
      fetchTopicddl(value, formData.subject);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFormData((prevData) => ({
      ...prevData,
      pdfFile: file,
    }));
  };

  const handleSave = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/OfflineLessoon/Id?Id=${LessionId}`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId: formData.class,
          subId: formData.subject || 2,
          lessonName: formData.lession,
          lessonContent: formData.Content,
          lessionPdfUrl: 'string',
        }),
      });
      if (response.ok) {
        setShowSuccessModal(true);
      } else {
        console.error('Failed to save form data');
      }
    } catch (error) {
      console.error('Save operation error:', error);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const fetchClassddl = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setClassName(responseData);
        } else {
          console.error('No data found for classes');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch class data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchSubjectddl = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Question/ddlSubject`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId,
          subjectId: 0,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setSubjectName(responseData);
        } else {
          console.error('No data found for subjects');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch subject data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchTopicddl = async (classId, subjectId) => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Question/ddlLession`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          classId,
          subjectId,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data !== null) {
          setTopicName(responseData);
        } else {
          console.error('No data found for topics');
        }
        if (responseData.msg && responseData.msg !== 'Record Not Found') {
          console.error('API error:', responseData.msg);
        }
      } else {
        console.error('Failed to fetch topic data');
        // alert('Failed to fetch topic data');
        setSnackbarMessage('Failed to fetch topic data');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const fetchLessionDetails = async () => {
    try {
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/OfflineLessoon/GetLesson`;
      const token = sessionStorage.getItem('token');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        console.log('Fetched Lesson Details:', responseData);
        const lessionDetails = responseData.find((item) => item.lessonId == LessionId);
        if (lessionDetails) {
          console.log('Found Lesson Details:', lessionDetails);
          setFormData({
            class: lessionDetails.classId,
            subject: lessionDetails.subjectName || '',
            lession: lessionDetails.lessonName,
            Content: lessionDetails.lessonContent,
          });
        } else {
          console.error('No data found for this lesson');
        }
      } else {
        console.error('Failed to fetch lesson details');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  useEffect(() => {
    fetchClassddl();
    if (LessionId) {
      fetchLessionDetails();
    }
  }, [LessionId]);

  return (
    <Box p={3}>
      {/* Header Box with Title + Info Button */}
      <Box
        sx={{
          backgroundColor: '#0B1F40', // dark navy blue
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          maxWidth: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Update Lesson
        </Typography>

        {/* ── Info Button ── */}
        <Tooltip title="About this page" arrow>
          <IconButton
            onClick={() => setInfoOpen(true)}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.75)",
              border: "1.5px solid rgba(255,255,255,0.35)",
              borderRadius: "50%",
              width: 30,
              height: 30,
              ml: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#ffffff",
                backgroundColor: "rgba(100,181,246,0.2)",
                borderColor: "#64B5F6",
                transform: "scale(1.1)",
                boxShadow: "0 0 8px rgba(100,181,246,0.4)",
              },
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Paper elevation={3} sx={{ padding: 2, marginBottom: 2, marginTop: 1 }}>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel>Class *</InputLabel>
          <Select
            value={formData.class}
            label="Class *"
            onChange={(e) => handleChange('class', e.target.value)}
          >
            {className.map((item) => (
              <MenuItem key={item.classId} value={item.classId}>
                {item.className}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel>Subject *</InputLabel>
          <Select
            value={formData.subject}
            label="Subject *"
            onChange={(e) => handleChange('subject', e.target.value)}
          >
            {subjectName.map((item) => (
              <MenuItem key={item.subjectId} value={item.subjectId}>
                {item.subjectName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Lesson"
          value={formData.lession}
          onChange={(e) => handleChange('lession', e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          fullWidth
          label="Lesson Content"
          multiline
          rows={4}
          value={formData.Content}
          onChange={(e) => handleChange('Content', e.target.value)}
          sx={{ marginBottom: 2 }}
        />
      </Paper>

      <Box>
        <Tooltip title={(!formData.class || !formData.subject) && "Please fill required fields"} arrow><span>
          <Button variant="contained" color="primary" onClick={handleSave} sx={{
            marginRight: 1, width: "90px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold'
          }}
            disabled={!formData.class || !formData.subject}>
            SAVE
          </Button></span></Tooltip>
        <Button variant="contained" color="error" onClick={handleCancel} sx={{
          width: "90px",
          height: "50px",
          padding: "10px 0",
          fontWeight: 'bold'
        }}>
          CANCEL
        </Button>
      </Box>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Lesson Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Lesson has been Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* ── Info Dialog ── */}
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
            Update Lesson — Page Guide
          </Box>
          
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 2.5 }}>

          {/* Purpose */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
            Use this form to update an existing offline lesson record. All fields are pre-filled
            with the current lesson data. Make your changes and click Save to apply the update.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Fields */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Field Reference
          </Typography>

          <List dense disablePadding>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SchoolIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Class <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Select the class this lesson belongs to. Changing the class reloads the Subject dropdown automatically."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SubjectIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Subject <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Select the subject for this lesson. The subject list is filtered based on the selected class."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <MenuBookIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Lesson</Typography>}
                secondary="The name or title of the lesson (e.g. Chapter 3: Photosynthesis)."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <ArticleOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Lesson Content</Typography>}
                secondary="The full body content or description of the lesson. Supports multiple lines of text."
              />
            </ListItem>

          </List>

          <Divider sx={{ my: 2 }} />

          {/* Buttons */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Buttons
          </Typography>
          <List dense disablePadding>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SaveOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Save</Typography>}
                secondary="Submits the updated lesson. Disabled until both Class and Subject are selected. A success modal appears on completion; clicking OK navigates back."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <ArrowBackIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Cancel</Typography>}
                secondary="Navigates back to the previous page immediately without saving any changes."
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Important notes */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Important Notes
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {[
              "Class and Subject are required — Save is disabled until both are selected.",
              "Selecting a new Class automatically refreshes the Subject dropdown.",
              "All fields are pre-filled with the existing lesson data on page load.",
              "Lesson and Lesson Content are optional but recommended for completeness.",
              "A success modal confirms the update; Cancel in the modal navigates back.",
            ].map((note, i) => (
              <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
                {note}
              </Typography>
            ))}
          </Box>

        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
          <Button
            onClick={() => setInfoOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#0B1F3D",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1565C0" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── End Info Dialog ── */}

    </Box>
  );
};

export default UpdateLession;